import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { VariablesGlobales } from '../services/globals';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

  public isActive: boolean;

  constructor(private encdec: EncryptDecryptService, public param: VariablesGlobales,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService) {
    this.http.get('https://api2.sitederecrutement.com/Home/GetCandidate?apikey=' + localStorage.getItem('apikey') + '&login=' + JSON.parse(localStorage.getItem('currentUser'))?.candidat_api, { responseType: 'text' }).subscribe(
      (result) => {
        const obj = JSON.parse(this.encdec.getDecrypt( result));
        if (obj.profil.profil_dispo === "Indisponible")
          this.isActive = false;
        else
          this.isActive = true;
      }
    );
  }

  desactivation() {
    this.http.get('https://api2.sitederecrutement.com/Home/StatusCandidate?apikey=' + localStorage.getItem('apikey') + '&id=' + JSON.parse(localStorage.getItem('currentUser'))?.idcandidat + '&activation=false', { responseType: 'text' }).subscribe(
      (result) => {
        const datas = JSON.parse(this.encdec.getDecrypt( result));
        const obj = JSON.parse(datas);
        if(obj.result)
          this.isActive = false;
      }
    );
  }

  activation() {
    this.http.get('https://api2.sitederecrutement.com/Home/StatusCandidate?apikey=' + localStorage.getItem('apikey') + '&id=' + JSON.parse(localStorage.getItem('currentUser'))?.idcandidat + '&activation=true', { responseType: 'text' }).subscribe(
      (result) => {
        const datas = JSON.parse(this.encdec.getDecrypt( result));
        const obj = JSON.parse(datas);
        if (obj.result)
          this.isActive = true;
      }
    );
  }

  suppression() {
    this.http.get('https://api2.sitederecrutement.com/Home/SupprCandidate?apikey=' + localStorage.getItem('apikey') + '&id=' + JSON.parse(localStorage.getItem('currentUser'))?.idcandidat, { responseType: 'text' }).subscribe(
      (result) => {
        const datas = JSON.parse(this.encdec.getDecrypt( result));
        const obj = JSON.parse(datas);
        if (obj.result) {        
          this.router.navigate(['home']);
          this.authService.logout();
        }
      }
    );
  }

  ngOnInit(): void {
  }

}
